import {IconProps} from '@/components/svg/study-icon'

export const QuestionLibraryIcon: React.FC<IconProps> = ({ size = 20, className, ...rest }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
        {...rest}
    >
        <path
            d='M13 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H7L10 4H17C17.5304 4 18.0391 4.21071 18.4142 4.58579C18.7893 4.96086 19 5.46957 19 6V8.5M17 19V19.01M17 16C17.4483 15.9986 17.8832 15.8468 18.235 15.569C18.5868 15.2911 18.8352 14.9033 18.9406 14.4675C19.0459 14.0318 19.0019 13.5733 18.8158 13.1655C18.6297 12.7576 18.3122 12.424 17.914 12.218C17.5162 12.0142 17.0611 11.951 16.6228 12.0387C16.1845 12.1264 15.7888 12.3598 15.5 12.701'
            stroke='currentColor'
            strokeWidth={1.5}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
)